var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.226 16L3.613 19.6129L0 16L3.613 12.3871L7.226 16ZM16 7.2258L22.1937 13.4193L25.8065 9.80645L16 0L6.19375 9.80645L9.8065 13.4193L16 7.2258ZM28.3872 12.3871L24.7743 16L28.3872 19.6129L32 16L28.3872 12.3871ZM16 24.7742L9.8065 18.5807L6.19375 22.1936L16 32L25.8065 22.1936L22.1937 18.5807L16 24.7742ZM16 19.6129L19.613 16L16 12.3871L12.3872 16L16 19.6129Z",
    fill: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.c632d4f2a17a144ff253373aef2656f9.svg";
export { ForwardRef as ReactComponent };